/**
 * Shared Sentry options used by client, server, and edge inits.
 * Keep this free of runtime-specific imports so all targets can use it.
 */

export const sentryDsn = process.env.NEXT_PUBLIC_SENTRY_DSN

export const sentryEnvironment =
  process.env.NEXT_PUBLIC_VERCEL_ENV ??
  process.env.VERCEL_ENV ??
  process.env.NEXT_PUBLIC_DEPLOYMENT_ENV ??
  process.env.NODE_ENV ??
  'development'

/** Full traces in local/dev; sample in production to control volume/cost. */
export const sentryTracesSampleRate = process.env.NODE_ENV === 'production' ? 0.1 : 1

/** Only send events when a DSN is configured. */
export const sentryEnabled = Boolean(sentryDsn)
